import { ReactNode }  from 'react'
import './Style/Modal.css'
import { useModal } from '../../Hooks/useModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
type ModalProps = {
    children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ children }) => {
    const { closeModal } = useModal();
    
    return (
        <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <button className='modal-close' onClick={closeModal}>
                    <FontAwesomeIcon icon={faXmark} size='2x'/>
                </button>
                {children}
            </div>
        </div> 
    )
}

export default Modal